import { FromDto } from '../interfaces'

export function populate<Dto, Domain extends FromDto<Dto>>(domain: Domain, dto: Dto): void {
    domain.fromDto(dto)
}
